// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_html2canvas_dist_html2canvas_js":"91734753542fb729","node_modules_dompurify_dist_purify_js":"a8c703cc3c117329","node_modules_canvg_lib_index_es_js":"75e070b218b2a9df"}[chunkId] + ".js";
};